import React from 'react';
import commonStyles from '../Point.module.scss';
import Title from '../../shared/Title/Title';
import ConsumptionsTable from './Table/Table';
import Filter from './Filters/Filter';
import { getTranslation } from '../../../utils/translation';

export default function Consumptions() {
    return (
        <>
            <Title title={getTranslation('title.consumptions')} />
            <Filter />
            <main className={commonStyles.main}>
                <ConsumptionsTable />
            </main>
        </>
    );
}
